import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Grid } from "semantic-ui-react";
import CountUp from "react-countup";
import { TextAligner } from "../helpers/text-aligner";
import { get_financial_rent, get_company_tco, get_vehicle_tco, get_taxes } from "../helpers/tco-calculator";
import { updateTco, updateInitialTco } from "../actions/actions-tco";
import languages from "../languages.json";

export default connect(
    mapStateToProps,
    { updateTco, updateInitialTco }
)(
    class TotalTco extends Component {
        render() {
            const t = languages[this.props.language];

            const financial_rent = get_financial_rent(this.props.data);
            const vehicle_tco = get_vehicle_tco(this.props.data);
            const company_tco = get_company_tco(this.props.data);
            const taxes_amount = get_taxes(this.props.data);

            this.props.updateTco("financial_rent", financial_rent);
            this.props.updateTco("vehicle_tco", vehicle_tco);
            this.props.updateTco("company_tco", company_tco);
            this.props.updateTco("taxes_amount", taxes_amount);

            const initial_financial_rent = get_financial_rent(this.props.parameters);
            const initial_vehicle_tco = get_vehicle_tco(this.props.parameters);
            const initial_company_tco = get_company_tco(this.props.parameters);
            const initial_taxes_amount = get_taxes(this.props.parameters);

            this.props.updateInitialTco("initial_financial_rent", initial_financial_rent);
            this.props.updateInitialTco("initial_vehicle_tco", initial_vehicle_tco);
            this.props.updateInitialTco("initial_company_tco", initial_company_tco);
            this.props.updateInitialTco("initial_taxes_amount", initial_taxes_amount);

            return (
                <Table singleLine compact="very">
                    <Table.Body>
                        <Table.Row active style={{ background: "#808080" }}>
                            <Table.Cell width={10}>
                                <strong>TCO</strong>
                            </Table.Cell>
                            <Table.Cell width={6}>
                                <Grid verticalAlign="middle" style={{ paddingRight: "15px" }}>
                                    <Grid.Column width={5}>
                                        <strong>
                                            <CountUp
                                                start={300}
                                                end={financial_rent + vehicle_tco + company_tco}
                                                duration={0.5}
                                                useEasing={true}
                                                separator={this.props.language === "en-gb" ? "," : " "}
                                                suffix={" " + t.parameters.money}
                                                redraw={true}
                                            />
                                            &nbsp; (
                                            <CountUp
                                                start={300}
                                                end={
                                                    financial_rent +
                                                    vehicle_tco +
                                                    company_tco -
                                                    (initial_financial_rent +
                                                        initial_vehicle_tco +
                                                        initial_company_tco)
                                                }
                                                duration={0.5}
                                                useEasing={true}
                                                separator={this.props.language === "en-gb" ? "," : " "}
                                                prefix={
                                                    financial_rent +
                                                        vehicle_tco +
                                                        company_tco -
                                                        (initial_financial_rent +
                                                            initial_vehicle_tco +
                                                            initial_company_tco) >=
                                                    0
                                                        ? "+ "
                                                        : " "
                                                }
                                                suffix={" " + t.parameters.money}
                                                redraw={true}
                                            />
                                            )
                                        </strong>
                                    </Grid.Column>
                                    <Grid.Column width={5}>
                                        {TextAligner(
                                            (
                                                initial_financial_rent +
                                                initial_vehicle_tco +
                                                initial_company_tco
                                            ).toLocaleString(this.props.language),
                                            t.parameters.money,
                                            true,
                                            true
                                        )}
                                    </Grid.Column>
                                    <Grid.Column width={6}>
                                        {TextAligner(
                                            <CountUp
                                                start={300}
                                                end={Math.round(
                                                    (100 *
                                                        (financial_rent +
                                                            vehicle_tco +
                                                            company_tco -
                                                            (initial_financial_rent +
                                                                initial_vehicle_tco +
                                                                initial_company_tco))) /
                                                        (initial_financial_rent +
                                                            initial_vehicle_tco +
                                                            initial_company_tco)
                                                )}
                                                duration={0.5}
                                                useEasing={true}
                                                separator={this.props.language === "en-gb" ? "," : " "}
                                                prefix={
                                                    financial_rent +
                                                        vehicle_tco +
                                                        company_tco -
                                                        (initial_financial_rent +
                                                            initial_vehicle_tco +
                                                            initial_company_tco) >=
                                                    0
                                                        ? "+ "
                                                        : " "
                                                }
                                                redraw={true}
                                            />,
                                            "%",
                                            true
                                        )}
                                    </Grid.Column>
                                </Grid>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            );
        }
    }
);

function mapStateToProps(state) {
    return {
        data: state.reducerData,
        parameters: state.reducerParameters,
        language: state.reducerLanguage,
    };
}



// WEBPACK FOOTER //
// ./src/components/totalTco.js